import React from 'react';
import { Navbar } from '../../components/Navbar';

import ResourcesBG from '../../assets/ResourcesBG.jpg';
import { ContentBox } from '../../components/ContentBox';

import biochar_title from '../../assets/biochar_title_screen.png';

const ResourcesPage = () => {
  return (
    <div className="bg-sky-200">
      <Navbar src={ResourcesBG} pageName={`Resources`} />
      <ContentBox
        bgColor={'#CFE3F6'}
        titleColor={'#2E7A32'}
        title="Funding to support climate-smart agriculture"
        content={
          <div>
            The following funding programs have very manageable reporting
            requirements:
            <ul
              className={`list-inside indent-3 inset-1`}
              style={{ listStyleType: 'square' }}
            >
              <li>
                Elevated Foods{' '}
                <a
                  href="https://www.elevatedfoods.com/pages/climate-smart-commodities"
                  target="partner"
                  className="text-lime-700 hover:text-emerald-700 hover:underline"
                >
                  Climate Smart Commodities
                </a>
                .
              </li>
              <li>
                Zero Foodprint{' '}
                <a
                  href="https://www.zerofoodprint.org/compost"
                  target="partner"
                  className="text-lime-700 hover:text-emerald-700 hover:underline"
                >
                  Compost Connector Grants
                </a>
                .
              </li>
              <li>
                Zero Foodprint{' '}
                <a
                  href="https://www.zerofoodprint.org/apply"
                  target="partner"
                  className="text-lime-700 hover:text-emerald-700 hover:underline"
                >
                  Restore Grants
                </a>
                .
              </li>
            </ul>
            <p>
              Contact your local{' '}
              <a
                href="https://carcd.org/page/interactive-rcd-map"
                target="partner"
                className="text-lime-700 hover:text-emerald-700 hover:underline"
              >
                Resource Conservation District{' '}
              </a>
              to learn more about other resources for climate-smart agriculture.
              Your RCD can help you determine what practices are likely to be
              optimal for your land, and may be able to provide access to other
              funding streams. For example, adopting certain climate-smart
              practices may qualify your farm to earn additional revenue through
              carbon credit programs.
            </p>
          </div>
        }
        maxContentWidth="max-w-7xl"
      />

      <ContentBox
        bgColor="#A8C356"
        title="What is climate-smart agriculture?"
        titleColor="#2E7A32"
        content={
          <div>
            <p>
              Climate-smart agriculture means adopting regenerative land
              management practices that increase resilience against climate
              impacts &mdash; improving soil fertility and reducing water
              requirements. This includes <strong>carbon farming</strong>,
              irrigation management, and aquifer recharge practices.
            </p>
            &nbsp; &nbsp;
            <p>
              <h1 className={`font-bold text-2xl text-lime-800`}>
                Benefits to the farmer
              </h1>
              Climate-smart agriculture can solve multiple problems farmers face
              simultaneously:
              <ul
                className={`list-inside indent-3 inset-1`}
                style={{ listStyleType: 'square' }}
              >
                <li>
                  It can dramatically decrease soil erosion and degradation.
                </li>
                <li>
                  It can assist with water infiltration and retention
                  (especially important in times of drought).
                </li>
                <li>
                  It reduces the need for pesticides, herbicides and synthetic
                  fertilizers over time, thereby reducing or eliminating the
                  costs of those inputs.
                </li>
                <li>
                  It reduces the amount of air pollution created by tillage.
                </li>
                <li>
                  It reduces the amount of fossil fuels used and the associated
                  costs by reducing tractor passes.
                </li>
              </ul>
            </p>
            &nbsp;
            <p>
              Most farmers and ranchers also report{' '}
              <strong>increased profits without reduction in yields</strong>{' '}
              once the initial transition is complete.
            </p>
            &nbsp;
            <p>
              <h1 className={`font-bold text-2xl text-lime-800`}>
                For more information
              </h1>
              <ul
                className={`list-inside indent-3 inset-1`}
                style={{ listStyleType: 'square' }}
              >
                <li>
                  Contact your local{' '}
                  <a
                    href="https://carcd.org/page/interactive-rcd-map"
                    target="partner"
                    className="text-lime-700 hover:text-emerald-700 hover:underline"
                  >
                    Resource Conservation District
                  </a>{' '}
                  to learn more about climate-smart agriculture.
                </li>
                <li>
                  Visit the{' '}
                  <a
                    href="https://www.carboncycle.org/what-is-carbon-farming/"
                    target="partner"
                    className="text-lime-700 hover:text-emerald-700 hover:underline"
                  >
                    Carbon Cycle Institute
                  </a>{' '}
                  to learn more about carbon farming.
                </li>
                <li>
                  Watch "The Impact of Biochar" on YouTube:{' '}
                  <a
                    href="https://www.youtube.com/watch?v=-ogN_toQ-30"
                    target="video"
                  >
                    <img
                      className={`w-[400px] mx-auto my-4`}
                      src={biochar_title}
                      alt="The Impact of Biochar"
                    />
                  </a>
                </li>
              </ul>
            </p>
          </div>
        }
        // contentColor="#FFFFFF"
        maxContentWidth="max-w-7xl"
      />
      {/* <ContentBox
        bgColor="#FFFFFF"
        title="Carbon farming"
        content={
          <div>
            <p>Contact your local <a href="https://carcd.org/page/interactive-rcd-map"  target="partner"
                className="text-lime-700 hover:text-emerald-700 hover:underline">Resource Conservation District</a> to learn more about climate-smart agriculture.</p>
            &nbsp;
            <p><img className={`w-[800px] mx-auto my-4`} src={CarbonFarmSketch} alt="The traditional process of project development for Conservation Districts." /></p>
            &nbsp;
            <p>
              The carbon farm plan was developed by <a href='https://www.carboncycle.org/' target='partners'>Carbon Cycle Institute</a>.
            </p>
          </div>
        }
        colorContent="#000000"
      /> */}
    </div>
  );
};

export { ResourcesPage };
